import { ASSET_ICON } from '../constants'
import type { BrandInfo, CandidaturaPublica, VagaResumo } from '../types'
import { formatInscrito, localStr, statusBadgeClass } from '../utils'
import { JobBrand } from './JobBrand'
import { ProcessSteps } from './ProcessSteps'

interface MinhasVagasProps {
  loggedIn: boolean
  carregando: boolean
  minhas: CandidaturaPublica[]
  processoPassos: string[]
  brandFor: (v: VagaResumo) => BrandInfo
  onLogin: () => void
  onVerEmpregos: () => void
  onVerVaga: (id: string) => void
}

export function MinhasVagas({
  loggedIn,
  carregando,
  minhas,
  processoPassos,
  brandFor,
  onLogin,
  onVerEmpregos,
  onVerVaga,
}: MinhasVagasProps) {
  return (
    <div className="cr-view-minhas">
      <div className="cr-card cr-minhas-head">
        <h2>Minhas vagas</h2>
        <p className="cr-muted">Acompanhe o andamento das suas candidaturas no Grupo HI.</p>
      </div>
      <div aria-live="polite">
        {!loggedIn && (
          <div className="cr-card cr-minhas-empty">
            <span className="cr-emblem-plate cr-emblem-plate--md">
              <img src={ASSET_ICON} width={56} height={56} alt="" />
            </span>
            <h3>Entre para ver suas vagas</h3>
            <p className="cr-muted">
              Faça login com a conta usada na candidatura para acompanhar o processo no Grupo HI.
            </p>
            <button type="button" className="cr-btn cr-btn-primary" onClick={onLogin}>
              Entrar
            </button>
          </div>
        )}
        {loggedIn && carregando && <div className="cr-loading">Carregando suas vagas…</div>}
        {loggedIn && !carregando && !minhas.length && (
          <div className="cr-card cr-minhas-empty">
            <span className="cr-emblem-plate cr-emblem-plate--md">
              <img src={ASSET_ICON} width={56} height={56} alt="" />
            </span>
            <h3>Você ainda não se candidatou a nenhuma vaga</h3>
            <p className="cr-muted">Explore as oportunidades abertas no Grupo HI e envie sua candidatura.</p>
            <button type="button" className="cr-btn cr-btn-primary" onClick={onVerEmpregos}>
              Ver vagas
            </button>
          </div>
        )}
        {loggedIn &&
          !carregando &&
          minhas.map((c, idx) => {
            const v = c.vaga || ({} as VagaResumo)
            const brand = brandFor(v)
            const meta = [brand.nome, localStr(v), v.modalidade_display || v.modalidade]
              .filter(Boolean)
              .join(' · ')
            const quando = formatInscrito(c.inscrito_em)
            return (
              <article key={`${v.id || idx}-${c.inscrito_em || idx}`} className="cr-card cr-minhas-card">
                <div className="cr-minhas-card-top">
                  <div>
                    <JobBrand brand={brand} />
                    <h3 className="cr-minhas-title">{v.titulo || 'Vaga'}</h3>
                    <p className="cr-job-meta">{meta || 'Brasil'}</p>
                    {quando && <p className="cr-minhas-date">Inscrito em {quando}</p>}
                  </div>
                  <span className={`cr-status-badge ${statusBadgeClass(c.status_publico)}`}>
                    {c.status_label || 'Em andamento'}
                  </span>
                </div>
                <ProcessSteps
                  doneCount={c.passos_concluidos ?? 0}
                  passos={processoPassos}
                  compact
                />
                <div className="cr-minhas-card-actions">
                  {v.id && (
                    <button
                      type="button"
                      className="cr-btn cr-btn-ghost"
                      onClick={() => onVerVaga(v.id)}
                    >
                      Ver vaga
                    </button>
                  )}
                </div>
              </article>
            )
          })}
      </div>
    </div>
  )
}
